import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const ShopAdminRoleIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M12 22C12 22 20 18 20 12V5.00002L12 2.00002L4 5.00002V12C4 18 12 22 12 22Z"
                fill="none"
                stroke={props.htmlColor || '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.2 16.7998C10.7522 16.7998 11.2 16.3521 11.2 15.7998C11.2 15.2475 10.7522 14.7998 10.2 14.7998C9.64767 14.7998 9.19995 15.2475 9.19995 15.7998C9.19995 16.3521 9.64767 16.7998 10.2 16.7998Z"
                fill={props.htmlColor || '#21272E'}
            />
            <path
                d="M14.5 16.7998C15.0523 16.7998 15.5 16.3521 15.5 15.7998C15.5 15.2475 15.0523 14.7998 14.5 14.7998C13.9477 14.7998 13.5 15.2475 13.5 15.7998C13.5 16.3521 13.9477 16.7998 14.5 16.7998Z"
                fill={props.htmlColor || '#21272E'}
            />
            <path
                d="M6.69995 7H8.41421L9.56276 12.7385C9.60195 12.9358 9.70929 13.113 9.86599 13.2392C10.0227 13.3653 10.2188 13.4323 10.4199 13.4285H14.5855C14.7867 13.4323 14.9827 13.3653 15.1394 13.2392C15.2961 13.113 15.4035 12.9358 15.4427 12.7385L16.1284 9.14282H8.84277"
                fill="none"
                stroke={props.htmlColor || '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
